import { tradingSummary } from '@/utils/tradingSummary';
import AnimatedBar from '@/components/base/AnimatedBar';
import CountUp from '@/components/base/CountUp';
import StepSection from './StepSection';

function StepDirection() {
  const longPercent = tradingSummary.longPercent;
  const shortPercent = tradingSummary.shortPercent;

  return (
    <StepSection
      id="step-04"
      index="04"
      stage="filter"
      title="Choose A Direction"
      subtitle="The recorded system activity includes both long and short positions."
      body="The recorded trades show that the EA has operated in both directions rather than relying exclusively on long or short positions."
      reverse
    >
      <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
        <div className="flex items-center justify-between px-4 md:px-5 h-11 border-b border-background-200 bg-background-100">
          <span className="flex items-center gap-2 text-[11px] font-data tracking-widest text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
            ACTIVITY LEDGER
          </span>
          <span className="text-[10px] font-data tracking-widest text-foreground-400">
            RECORDED · {tradingSummary.totalTrades} TRADES
          </span>
        </div>

        <div className="px-4 md:px-5 pt-4 pb-3.5 border-b border-background-200">
          <div className="flex items-center justify-between">
            <span className="text-[10px] font-data tracking-[0.22em] text-foreground-400">
              DIRECTION SPLIT
            </span>
            <span className="font-data text-[10px] tracking-widest text-foreground-500">
              LONG / SHORT
            </span>
          </div>
          <div className="mt-3 flex h-2.5 w-full overflow-hidden rounded-full bg-background-200">
            <AnimatedBar percent={longPercent} className="h-full bg-primary-500" />
            <AnimatedBar percent={shortPercent} className="h-full bg-foreground-800" />
          </div>
          <div className="mt-2.5 flex items-center justify-between">
            <span className="flex items-center gap-1.5 font-data text-[10px] tracking-widest text-foreground-600">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              LONG {longPercent.toFixed(1)}%
            </span>
            <span className="flex items-center gap-1.5 font-data text-[10px] tracking-widest text-foreground-600">
              SHORT {shortPercent.toFixed(1)}%
              <span className="w-1.5 h-1.5 rounded-full bg-foreground-800"></span>
            </span>
          </div>
        </div>

        <div className="divide-y divide-background-200">
          <div className="flex items-center gap-3 px-4 md:px-5 py-3.5">
            <span className="w-2 h-2 shrink-0 rounded-full bg-primary-500"></span>
            <div className="min-w-0 flex-1">
              <p className="text-[13px] font-semibold text-foreground-900">Long · Buy</p>
              <p className="text-[11px] text-foreground-500">Recorded buy positions</p>
            </div>
            <span className="font-data text-[15px] font-semibold text-foreground-950">
              <CountUp value={tradingSummary.longTrades} />
            </span>
            <span className="w-14 text-right font-data text-[11px] tracking-wider text-primary-700">
              {longPercent.toFixed(1)}%
            </span>
          </div>
          <div className="flex items-center gap-3 px-4 md:px-5 py-3.5">
            <span className="w-2 h-2 shrink-0 rounded-full bg-foreground-800"></span>
            <div className="min-w-0 flex-1">
              <p className="text-[13px] font-semibold text-foreground-900">Short · Sell</p>
              <p className="text-[11px] text-foreground-500">Recorded sell positions</p>
            </div>
            <span className="font-data text-[15px] font-semibold text-foreground-950">
              <CountUp value={tradingSummary.shortTrades} />
            </span>
            <span className="w-14 text-right font-data text-[11px] tracking-wider text-foreground-700">
              {shortPercent.toFixed(1)}%
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between border-t border-background-200 bg-background-100 px-4 md:px-5 py-3">
          <span className="font-data text-[10px] tracking-widest text-foreground-400">
            INSTRUMENT · XAUUSD
          </span>
          <span className="font-data text-[10px] tracking-widest text-foreground-500">
            BOTH DIRECTIONS ACTIVE
          </span>
        </div>
      </div>
    </StepSection>
  );
}

export default StepDirection;